<mat-card class="documents-card">
    <div class="title-container">
        <h3 #itemEditTable>Documents</h3>
        <div class="d-flex mm-gap-5">
            <button *ngIf="options.enableQRCodeUpload" color="primary" mat-stroked-button
                (click)="openQRCodeUploadDialog()">
                <mat-icon>qr_code_scanner</mat-icon>
                <span class="mm-ml-2">Scan to Upload</span>
            </button>
            <button *ngIf="options.enableDocumentUpload" color="primary" mat-flat-button
                (click)="openUploadDocumentDialog()">
                <mat-icon>add</mat-icon>
                <span class="mm-ml-2">{{addDocumentButtonLabel}}</span>
            </button>
        </div>
    </div>
    <div class="table-container mat-elevation-z1">
        <!-- Loading message -->
        <div *ngIf="loading && dataSource.data.length === 0" class="text-message">
            Loading documents...
        </div>

        <div class="progress-bar-wrapper">
            <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" [value]="0" color="primary"
                class="top-progress-bar" [class.invisible]="!loading">
            </mat-progress-bar>
        </div>

        <!-- Empty message -->
        <div *ngIf="!loading &&  dataSource.data.length === 0" class="text-message">
            No documents found.
        </div>

        <!-- Table -->
        <table mat-table *ngIf="dataSource.data.length > 0" [dataSource]="dataSource" class="documents-table">
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element">{{element.date |convertToLocalTime:'DD-MM-YYYY hh:mm A' }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element" class="name" (click)="downloadDocument(element.url)">
                    {{element.title}}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex mm-gap-4 flex-wrap">
                        <span class="document-type-chip" *ngFor="let tag of element.tags">
                            {{ tag.name }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="expiryDate">
                <th mat-header-cell *matHeaderCellDef class="align-center"> Expiry Date </th>
                <td mat-cell *matCellDef="let element" class="align-center">
                    {{ element.expiryDate ? (element.expiryDate | convertToLocalTime:'DD-MM-YYYY') : 'N/A' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="align-center"> Status </th>
                <td mat-cell *matCellDef="let element" class="align-center">{{getDocumentStatusLabel(element.status)}}
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="align-center"> Action </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container [ngSwitch]="options.actionMode">
                        <ng-container *ngSwitchCase="'normal'">
                            <div class="d-flex justify-content-center align-items-center flex-wrap mm-gap-8">
                                <button matTooltip="Download Document" color="primary" mat-icon-button
                                    class="action-btn" (click)="downloadDocument(element.url)">
                                    <mat-icon>download</mat-icon>
                                </button>
                                <button matTooltip="Edit Document" color="primary" mat-icon-button class="action-btn"
                                    (click)="openEditDocumentDialog(element)">
                                    <mat-icon>edit_square</mat-icon>
                                </button>
                                <button matTooltip="Delete Document" color="primary" mat-icon-button class="action-btn"
                                    *ngIf="element.status==1" (click)="openDeleteDocumentConfirmDialog(element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <button matTooltip="Restore Document" color="primary" mat-icon-button class="action-btn"
                                    *ngIf="element.status==3" (click)="openRestoreDocumentConfirmDialog(element)">
                                    <mat-icon>restore_from_trash</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container
                                *ngTemplateOutlet="viewOnlyTemplate; context: { $implicit: element }"></ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-template #viewOnlyTemplate let-element>
                        <div class="d-flex justify-content-center align-items-center flex-wrap mm-gap-8">
                            <button mat-icon-button color="accent" (click)="downloadDocument(element.url)"
                                matTooltip="View document">
                                <mat-icon>open_in_new</mat-icon>
                            </button>
                        </div>
                    </ng-template>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</mat-card>